/* ==========================================================
   CRO - pie del carrito. set. 2026

   DOS PANTALLAS, NO UNA. ERROR YA COMETIDO: la primera version solo
   toco `.cart-drawer__footer`, o sea el CAJON lateral. La pagina /cart
   -otra seccion, sections/main-cart.liquid- quedo sin cupon, sin monto
   en el boton y sin "O seguir comprando". El cliente lo vio antes que yo.

   Por eso ahora todo pasa por la tabla ZONAS. Si manana aparece una
   tercera pantalla de carrito, se agrega una entrada ahi y nada mas.

     cajon   .cart-drawer__footer                  cupon antes de [data-merge="footer"]
     pagina  .checkout-subtotal-container__right   cupon antes de [data-merge="total"]

   CUATRO AGREGADOS:
   1. El monto dentro del boton de pago: "PAGAR . S/ 161". El cliente ve
      cuanto se va a cobrar en el mismo elemento que lo compromete.
   2. "O seguir comprando" debajo del boton. En el cajon es un boton que
      lo cierra (el cliente vuelve donde estaba); en /cart es el enlace
      que el tema ya trae, solo se le empareja el texto y el estilo.
   3. Caja de codigo de descuento, ARRIBA del subtotal.
   4. La nota del pedido, sacada del pie gris y puesta arriba de el. Solo
      en el cajon: en /cart el tema ya la pone en la columna izquierda,
      lejos de la zona de decision.

   POR QUE EN JS Y NO EN EL LIQUID DE LAS SECCIONES:
   entre cart-drawer.liquid y main-cart.liquid hay 40KB. Bifurcar los dos
   complica cualquier actualizacion futura del tema. Y hay una propiedad
   del propio tema que hace esto seguro:

     newContent.querySelectorAll("[data-merge]").forEach(newEl => {
       targetEl.innerHTML = newEl.innerHTML          <- REEMPLAZA contenido
     })
     newContent.querySelectorAll("[data-merge-attributes]").forEach(newEl => {
       ...solo copia atributos...                    <- NO toca el contenido
     })

   .cart-drawer__footer y .checkout-subtotal-container son
   data-merge-attributes: su contenido NO se reemplaza al actualizar el
   carrito, asi que lo inyectado ahi sobrevive. Por eso el cupon se
   inserta FUERA del bloque data-merge, nunca dentro.

   El numero del boton se lee del subtotal, que si es data-merge y siempre
   llega correcto del servidor. NUNCA se calcula el total aca: se copia del
   que ya calculo Shopify. Un total inventado en el boton de pago seria
   peor que no tener total.

   ============================================================
   BUCLE INFINITO - ERROR YA COMETIDO EN ESTE ARCHIVO, LEER:

   El observer vigila la zona con subtree + characterData. Escribir
   span.textContent DENTRO de la zona ES una mutacion de la zona: dispara
   el observer, que vuelve a escribir, que vuelve a disparar. Bucle
   infinito que congela la pestana. Paso de verdad: colgo el navegador
   dos veces.

   Dos guardas, y hacen falta LAS DOS:
     a) bandera `aplicando`: el observer ignora las mutaciones propias.
     b) comparar antes de escribir: si el texto ya es el correcto, no se
        toca el DOM. Sin esto, cualquier reentrada vuelve al bucle.

   Si algun dia se agrega otra escritura aca dentro, tiene que pasar por
   escribirTexto() o repetir las dos guardas.
   ============================================================ */

(function () {

  var ZONAS = [
    {
      nombre: 'cajon',
      raiz: '.cart-drawer__footer',
      // El cupon va antes de este bloque para quedar arriba del subtotal.
      bloque: '[data-merge="footer"]',
      boton: '.checkout-buttons .btn',
      // De donde se vuelve a pedir el bloque al servidor. cart-drawer.liquid
      // esta envuelto en {% unless template.name == 'cart' %}, asi que
      // pedirlo desde /cart devolveria vacio: se pide desde la home.
      url: '/?section_id=cart-drawer',
      seguir: 'inyectar',
      nota: 'mover'
    },
    {
      nombre: 'pagina',
      raiz: '.checkout-subtotal-container__right',
      bloque: '[data-merge="total"]',
      boton: 'button[name="checkout"]',
      url: '/cart',
      // Aca el tema ya trae <a class="continue-shopping">: se reusa, no se
      // duplica. Navega a una coleccion, que en /cart es lo correcto
      // porque no hay cajon que cerrar.
      seguir: 'reusar'
      // Sin `nota`: en /cart la nota ya vive en
      // .checkout-subtotal-container__left, o sea en la otra columna. No
      // se interpone entre el total y el boton, no hay nada que mover.
    }
  ];

  var TEXTO_SEGUIR = 'O seguir comprando';

  /* QUE PASA CUANDO NO SE PUEDE APLICAR - MEDIDO, NO SUPUESTO.

     Los cuatro codigos activos estan limitados por segmento de cliente y
     con appliesOncePerCustomer:
       Newsletter  -> "Suscriptores de correo electronico"      (890 usos)
       Cumpleanos  -> "Clientes que compraron al menos una vez"
       Vuelve      -> tres segmentos
       Judge.me    -> "Clientes que no han comprado"

     PRIMERA CONCLUSION, EQUIVOCADA: se penso que un invitado sin sesion
     iniciada no podria aplicarlos, porque Shopify no sabe a que segmento
     pertenece. El aviso se redacto alrededor de esa idea.

     COMPROBACION CON SESION LIMPIA (curl, sin cookies previas, sin login):
       carrito 2900 -> /discount/Newsletter -> carrito 2610
     O sea que SI aplica. El carrito lo aplica de forma optimista sin saber
     quien es el visitante. Lo que habia fallado era la sesion del
     navegador de pruebas, gastada despues de ~20 intentos seguidos con
     codigos validos e invalidos.

     Entonces el aviso volvio a lo unico cierto: no se pudo aplicar. Las
     causas reales son mal escrito, vencido, o ya usado por ese cliente.
     La mas frecuente de lejos es la primera, y es la unica sobre la que
     el cliente puede hacer algo: por eso el aviso apunta ahi.

     PENDIENTE DE CONFIRMAR CON UN PEDIDO REAL: el checkout vuelve a
     verificar la elegibilidad. Alguien que NO esta en el segmento podria
     ver el 10% en el carrito y perderlo en la pantalla de pago. No se
     probo porque habria creado un checkout de mentira en la tienda. Si
     llega a pasar, la solucion es de configuracion -abrir el descuento a
     "Todos los clientes"- no de este archivo. */

  var observers = [];
  var aplicando = false;

  // Unico punto de escritura: compara antes de tocar el DOM.
  function escribirTexto(el, valor) {
    if (el.textContent === valor) return false;
    el.textContent = valor;
    return true;
  }

  function raizDe(zona) { return document.querySelector(zona.raiz); }

  function textoSubtotal(raiz) {
    var st = raiz.querySelector('.subtotal .theme-money');
    return st ? st.textContent.trim() : '';
  }

  /* ---------- La nota, fuera del pie gris ------------------
     MEDIDO EN LOS PEDIDOS REALES antes de decidir: de los ultimos 250
     pedidos (#4689 al #4939, 40 dias) UNO trae nota, el #4908: "ENVIAR EL
     DIA VIERNES". O sea 0.4%.

     Con ese numero la nota no mueve la conversion ni para bien ni para
     mal. Se conserva por una razon operativa, no de conversion: lo que
     escribio esa unica persona es una instruccion de CUANDO entregar, y
     eso es justo lo que evita una entrega fallida. En Lima una entrega
     fallida cuesta el reparto de ida y de vuelta.

     PERO NO DONDE ESTABA. El tema la dibuja dentro de [data-merge="footer"],
     o sea entre el subtotal y el boton de pagar: partia en dos lo que
     decide. Aca se mueve al final de .cart-drawer__content, arriba del
     bloque gris -donde la ponen las tiendas de referencia-. Disponible
     para el que la necesita, invisible en el momento de decidir.

     EL DETALLE QUE HAY QUE ENTENDER: [data-merge="footer"] se reescribe
     entero en cada actualizacion del carrito, asi que el servidor vuelve
     a dibujar la nota adentro del pie cada vez. No alcanza con moverla una
     vez: en cada pasada hay que descartar la copia nueva. Y se descarta la
     del pie, no la de afuera, porque la de afuera es la que tiene lo que
     el cliente escribio. */

  function moverNota(pie) {
    var destino = document.querySelector('.cart-drawer__content');
    if (!destino) return;

    var toggle = pie.querySelector('#CartDrawerNoteToggle');
    var caja = pie.querySelector('.cart-drawer__note');
    var fila = pie.querySelector('.lightly-spaced-row');

    if (toggle) {
      if (destino.querySelector('.gs-nota')) {
        toggle.remove();
        if (caja) caja.remove();
      } else {
        var envoltorio = document.createElement('div');
        envoltorio.className = 'gs-nota';
        envoltorio.appendChild(toggle);
        if (caja) envoltorio.appendChild(caja);
        destino.appendChild(envoltorio);
      }
    }

    // .lightly-spaced-row queda vacia (impuestos apagados + nota afuera) y
    // sumaria 14px de aire muerto arriba del subtotal. No se usa :empty
    // porque el Liquid le deja saltos de linea adentro y :empty falla.
    if (fila && !fila.children.length) fila.style.display = 'none';
  }

  /* ---------- Caja de codigo de descuento ------------------
     La tienda reparte codigos por newsletter (Newsletter 10%, Cumpleanos
     15%, Vuelve 15%, y los de referidos de Judge.me). Un codigo que el
     cliente YA TIENE en la mano y no encuentra donde poner es friccion
     pura: o abandona o se va a buscarlo al checkout. Por eso va aca.

     Va ARRIBA del subtotal a proposito: aplicar -> ver el total nuevo ->
     pagar. Si estuviera debajo, el cliente veria un total que ya no es el
     que va a pagar.

     VA SIEMPRE ABIERTA, por decision de la tienda. La primera version la
     puso cerrada detras de un renglon "Tengo un codigo de descuento", con
     este argumento: un campo de cupon vacio y visible le avisa a quien NO
     tiene codigo que existen codigos, y esa persona se va a buscar uno a
     Google en vez de pagar.
     Ese riesgo sigue existiendo y queda anotado aca. Se acepta porque la
     tienda reparte codigos de forma activa por newsletter: la proporcion
     de gente que llega CON codigo es alta, y a esa gente un renglon
     plegado le agrega un clic justo antes de pagar.

     COMO SE APLICA: /discount/CODIGO es el endpoint publico de Shopify;
     guarda el codigo en la sesion. Despues se le pregunta a /cart.js que
     quedo aplicado. No se calcula ningun descuento en el navegador: si el
     servidor no lo aplico, no se aplico.

     OJO CON LOS ID: hay paginas donde conviven las dos zonas, asi que el
     id del input lleva el nombre de la zona. Dos elementos con el mismo
     id rompen el <label for> y el lector de pantalla lee cualquiera.
     -------------------------------------------------------- */

  function htmlCupon(zona) {
    var id = 'gs-cupon-' + zona.nombre;
    return '' +
      '<div class="gs-cupon">' +
        '<div class="gs-cupon__fila">' +
          '<label class="visually-hidden" for="' + id + '">Código de descuento</label>' +
          '<input type="text" id="' + id + '" class="gs-cupon__input" autocomplete="off" autocorrect="off" spellcheck="false" placeholder="Código de descuento">' +
          '<button type="button" class="gs-cupon__aplicar">Aplicar</button>' +
        '</div>' +
        '<p class="gs-cupon__aviso" role="status" aria-live="polite"></p>' +
      '</div>';
  }

  function avisar(raiz, texto, estado) {
    var p = raiz.querySelector('.gs-cupon__aviso');
    if (!p) return;
    escribirTexto(p, texto || '');
    p.className = 'gs-cupon__aviso' + (estado ? ' gs-cupon__aviso--' + estado : '');
  }

  /* DOS FORMAS DE DESCUENTO, Y EL TEMA SOLO DIBUJA UNA EN EL PIE.
     Medido en la tienda:
       "Newsletter"  -> target_selection: "all"       -> cart_level_discount_applications
       "Cumpleanos"  -> target_selection: "entitled"  -> items[].discounts
     El pie solo lista los de nivel carrito (los de linea si se ven, pero
     abajo de cada producto).

     ERROR YA COMETIDO POR ESTO: una version detectaba mirando si habia
     .cart-discount en el HTML del pie. Con "Newsletter" acertaba y con
     "Cumpleanos" decia "no aplica" mientras el total bajaba de 29.00 a
     24.65. Un aviso que contradice el numero de al lado es peor que
     ninguno.

     Por eso se le pregunta a /cart.js, que es la misma verdad del
     servidor y trae los DOS niveles. Nunca se decide con el HTML. */

  function estadoCarrito() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var titulos = (c.cart_level_discount_applications || []).map(function (d) {
          return d.title;
        });
        (c.items || []).forEach(function (item) {
          (item.discounts || []).forEach(function (d) {
            if (titulos.indexOf(d.title) === -1) titulos.push(d.title);
          });
        });
        return { total: c.total_price, titulos: titulos };
      });
  }

  function refrescarBloque(zona) {
    var raiz = raizDe(zona);
    if (!raiz) return Promise.resolve();
    return fetch(zona.url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector(zona.bloque);
        var vivo = raiz.querySelector(zona.bloque);
        if (nuevo && vivo) vivo.innerHTML = nuevo.innerHTML;
      });
  }

  function aplicarCupon(zona) {
    var raiz = raizDe(zona);
    if (!raiz) return;
    var input = raiz.querySelector('.gs-cupon__input');
    var boton = raiz.querySelector('.gs-cupon__aplicar');
    if (!input || !boton) return;

    var codigo = input.value.trim();
    if (!codigo) {
      avisar(raiz, 'Escribe tu código.', 'error');
      input.focus();
      return;
    }
    if (boton.disabled) return;

    boton.disabled = true;
    avisar(raiz, 'Comprobando…', '');

    var antes;

    estadoCarrito()
      .then(function (e) {
        antes = e;
        // Shopify admite un codigo por pedido: uno valido reemplaza al
        // anterior y uno invalido lo deja igual.
        return fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' });
      })
      .then(function () { return estadoCarrito(); })
      .then(function (despues) {
        return refrescarBloque(zona).then(function () { return despues; });
      })
      .then(function (despues) {
        var restantes = antes.titulos.slice();
        var nuevos = despues.titulos.filter(function (t) {
          var i = restantes.indexOf(t);
          if (i === -1) return true;
          restantes.splice(i, 1);   // consumido: no cuenta como nuevo
          return false;
        });
        var mismoNombre = despues.titulos.some(function (t) {
          return t.toLowerCase() === codigo.toLowerCase();
        });

        if (nuevos.length || despues.total < antes.total) {
          input.value = '';
          avisar(raiz, 'Código aplicado. El total de arriba ya lo incluye.', 'ok');
        } else if (mismoNombre) {
          avisar(raiz, 'Ese código ya está aplicado.', 'ok');
        } else if (despues.titulos.length) {
          avisar(raiz, 'No se pudo aplicar. Sigue vigente: ' +
                 despues.titulos[0] + '.', 'error');
        } else {
          avisar(raiz, 'No pudimos aplicar ese código. Revisa que esté bien escrito.', 'error');
        }
        sincronizar();
        document.dispatchEvent(new CustomEvent('on:cart:change'));
      })
      .catch(function () {
        avisar(raiz, 'No pudimos comprobarlo. Intenta de nuevo.', 'error');
      })
      .then(function () { boton.disabled = false; });
  }

  function engancharCupon(zona, raiz) {
    var input = raiz.querySelector('.gs-cupon__input');
    if (input) {
      input.addEventListener('keydown', function (e) {
        // En /cart el cupon vive DENTRO del <form id="cartform">: sin este
        // preventDefault, Enter envia el formulario y recarga la pagina
        // antes de que se aplique nada.
        if (e.key === 'Enter') {
          e.preventDefault();
          aplicarCupon(zona);
        }
      });
    }

    var aplicar = raiz.querySelector('.gs-cupon__aplicar');
    if (aplicar) {
      aplicar.addEventListener('click', function () { aplicarCupon(zona); });
    }
  }

  /* ---------- montaje y sincronizacion -------------------- */

  function montarZona(zona) {
    var raiz = raizDe(zona);
    if (!raiz) return;

    // 1. Cupon: una sola vez, antes del bloque data-merge.
    var bloque = raiz.querySelector(zona.bloque);
    if (bloque && !raiz.querySelector('.gs-cupon')) {
      bloque.insertAdjacentHTML('beforebegin', htmlCupon(zona));
      engancharCupon(zona, raiz);
    }

    // 2. Monto dentro del boton de pago.
    var boton = raiz.querySelector(zona.boton);
    if (boton) {
      var monto = textoSubtotal(raiz);
      var span = boton.querySelector('.gs-btn-total');
      if (monto) {
        if (!span) {
          span = document.createElement('span');
          span.className = 'gs-btn-total';
          boton.appendChild(span);
        }
        // Espacios DUROS (U+00A0). Con espacio normal el navegador colapsa
        // el que abre el span contra el texto "Pagar" que lo precede y
        // queda "PAGAR· S/. 24.65". Medido: hueco de 0px.
        escribirTexto(span, ' · ' + monto);
      } else if (span) {
        // Sin subtotal legible, mejor sin numero que con uno dudoso.
        span.remove();
      }
    }

    // 3. "O seguir comprando".
    if (zona.seguir === 'inyectar') {
      var cont = raiz.querySelector('.checkout-buttons');
      if (cont && !raiz.querySelector('.gs-seguir')) {
        var b = document.createElement('button');
        b.type = 'button';
        // js-close-drawer es el enganche que ya usa el tema para cerrar.
        b.className = 'gs-seguir js-close-drawer';
        b.textContent = TEXTO_SEGUIR;
        cont.insertAdjacentElement('afterend', b);
      }
    } else {
      var enlace = raiz.querySelector('.continue-shopping');
      if (enlace) {
        enlace.classList.add('gs-seguir');
        escribirTexto(enlace, TEXTO_SEGUIR);
      }
    }

    // 4. La nota, fuera del pie gris.
    if (zona.nota === 'mover') moverNota(raiz);
  }

  function sincronizar() {
    if (aplicando) return;
    aplicando = true;
    observers.forEach(function (o) { o.disconnect(); });
    try {
      ZONAS.forEach(montarZona);
    } finally {
      observers.forEach(function (o) { o.reconectar(); });
      aplicando = false;
    }
  }

  function arrancar() {
    ZONAS.forEach(function (zona) {
      var raiz = raizDe(zona);
      if (!raiz || !window.MutationObserver) return;
      var mo = new MutationObserver(function () {
        if (aplicando) return;
        sincronizar();
      });
      mo.reconectar = function () {
        var r = raizDe(zona);
        if (r) mo.observe(r, { childList: true, subtree: true, characterData: true });
      };
      observers.push(mo);
    });
    sincronizar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  ['on:cart:add', 'on:cart:change', 'on:line-item:change', 'on:cart-drawer:after-open']
    .forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(sincronizar, 0); });
    });
})();
